module.exports = __webpack_public_path__ + "img/blog6-2.0d89baa6.webp";